<template>
  <div class="rank-div">
    <div class="rank-item" v-for="(item, index) in rankData" :key="`rank${index}`">
      <div class="rank-item-top">
        <div class="rank-item-top_left">
          <span :style="{ marginRight: '10px', color }">No.{{ index + 1 }}</span>
          <div style="flex: 1;overflow: hidden;">
            <span class="area-name">
              {{ item.area_name }}
            </span>
          </div>
        </div>
        <div class="rank-item-top_right">{{ item.total_ysx_amt }}万元</div>
      </div>
      <div class="rank-item-bottom" :style="{ borderColor: color }">
        <div class="speed" :style="{ background: color }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rank',
  props: {
    rankType: {
      type: String,
      default: 'province'
    },
    rankData: Array
  },
  computed: {
    color() {
      let color = this.rankType == 'province' ? 'rgb(19, 112, 251)' : 'rgb(61, 231, 201)';
      return color;
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 1px; /*对垂直流动条有效*/
  height: 2px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
  border-radius: 3px;
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 7px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: #e8e8e8;
}

/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
  background-color: rgba(0, 0, 0, 0);
}

/*定义右下角汇合处的样式*/
::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}
.rank-div {
  padding: 0 10px 10px 10px;
  font-size: 14px;
  letter-spacing: 0;
  height: calc(100% - 74px);
  overflow: auto;
  margin-top: 20px;
}
.rank-item {
  margin-bottom: 20px;
}
.rank-item:last-of-type {
  margin-bottom: 0;
}
.rank-item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
}
.rank-item-top_left {
  flex: 1;
  overflow: hidden;
  display: flex;
}
.rank-item-top_left .area-name {
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank-item-bottom {
  border-bottom: 1px solid;
}
.rank-item-bottom .speed {
  width: 60%;
  height: 6px;
  border-radius: 2px;
  margin-bottom: 4px;
}
</style>
